import React from 'react';

function ServiceCard({ number, title, description, isActive }) {
  return (
    <div className={`service-panel${isActive ? ' active' : ''}`}>
      <div className="service-panel-inner">
        <span className="service-panel-number">{number}</span>
        <div className="service-panel-body">
          <h3 className="service-panel-title">{title}</h3>
          <p className="service-panel-description">{description}</p>
        </div>
      </div>
    </div>
  );
}

export default ServiceCard;
